export const COL_CHECKBOX = "colCheckbox";
export const DEFAULT_COLUMN_WIDTH = 300;

export const getTableDefaultValue = ({ t, showDefaultColumnName }) => {
  const columnHeaderNames = {
    1: showDefaultColumnName
      ? "Physical (Large Equipment)"
      : t("project:column_number", { number: 1 }),
    2: showDefaultColumnName
      ? "Physical (Floor Space)"
      : t("project:column_number", { number: 2 }),
    3: showDefaultColumnName
      ? "Construction"
      : t("project:column_number", { number: 3 }),
  };

  return {
    columns: [
      {
        accessorKey: `col1`,
        id: "2",
        size: DEFAULT_COLUMN_WIDTH,
      },
      {
        accessorKey: `col2`,
        id: "3",
        size: DEFAULT_COLUMN_WIDTH,
      },
      {
        accessorKey: `col3`,
        id: "4",
        size: DEFAULT_COLUMN_WIDTH,
      },
    ],
    data: [
      {
        id: 1,
        col1: columnHeaderNames[1],
        col2: columnHeaderNames[2],
        col3: columnHeaderNames[3],
        isFixed: true,
        isHeader: true,
      },
      {
        id: 2,
        col1: "",
        col2: "",
        col3: "",
      },
      {
        id: 3,
        col1: "",
        col2: "",
        col3: "",
      },
      {
        id: 4,
        col1: "",
        col2: "",
        col3: "",
      },
    ],
  };
};
